<template>
  <v-select
    v-model="model"
    dense
    outlined
    item-text="nome"
    return-object
    :placeholder="placeholder"
    :label="label"
    :rules="[rules.required]"
    :items="items"
    :disabled="disabled || !cityId"
  />
</template>

<script>
import enderecoService from '@/services/sit-pedidos/endereco.service'

export default {
  name: 'DistrictSelect',

  props: {
    label: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      required: true,
    },

    value: {
      type: Object,
      default: ()=>({}),
    },

    disabled: {
      type: Boolean,
      default: ()=>(false),
    },

    cityId: {
      type: Number,
      default: ()=> null,
    },
  },

  data: () => ({
    items: [],

    rules: {
      required: value => !!value || "Esse campo deve ser preenchido"
    }
  }),

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    cityId(newValue) {
      this.load()
    }
  },

  mounted(){
    this.load()
  },

  methods: {
    load() {
      enderecoService.listAllDistrictsByCityId(this.cityId).subscribe((res)=>{
        this.items = res
      })
    }
  }
}
</script>
